import * as React from "react";
import styled from "styled-components";
import { API, graphqlOperation } from "aws-amplify";
import { getImage } from "graphql/queries";
import Button from "@material-ui/core/Button";

const BrandLogoItem = styled.div`
  flex: auto;
  width: 100px;
`;

const BrandLogoImg = styled.img`
  width: 100%;
  width: 100px;
`;

type Props = {
  logo: any;
  onClick: () => void;
};

export default function MainLogo(props: Props) {
  const { logo, onClick } = props;
  const [image, setImage] = React.useState();

  React.useEffect(() => {
    async function f() {
      if (logo) {
        const res = (await API.graphql(
          // @ts-ignore
          graphqlOperation(getImage, {
            id: logo.photID,
          })
        )) as any;

        setImage(res.data.getImage);
      }
    }
    f();
  }, [logo]);

  return (
    <BrandLogoItem onClick={() => onClick()}>
      {image && (
        <Button>
          <BrandLogoImg src={image.url} alt={image.alt} />
        </Button>
      )}
    </BrandLogoItem>
  );
}
